import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { SMAAsset } from "./Types";
export const getUrl = (assetId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/alt-asset/v1/smas/${assetId}`
    : `https://middleware.uat.farther.com/alt-asset/v1/smas/${assetId}`;
export default async function getSMA(assetId, config) {
    const { data } = await axios.get(getUrl(assetId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = SMAAsset.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getSMA] Could not parse";
        errorLog("getSMA", `Could not parse, ${decoded.error.message}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getSMA.js.map